// Client default values for Apollo cache data

export default {
  topicViewCard: true,
  ssrsTreeOpen: [],
  profileProccessed: false
}
